import script from "./ParallelSpiner.vue?vue&type=script&setup=true&lang=js"
export * from "./ParallelSpiner.vue?vue&type=script&setup=true&lang=js"

import "./ParallelSpiner.vue?vue&type=style&index=0&id=cace3d62&lang=css"

const __exports__ = script;

export default __exports__